import { render, staticRenderFns } from "./MediaComponent.vue?vue&type=template&id=06ff498f&scoped=true&"
import script from "./MediaComponent.vue?vue&type=script&lang=ts&"
export * from "./MediaComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MediaComponent.vue?vue&type=style&index=0&id=06ff498f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff498f",
  null
  
)

export default component.exports